const ProductCartRecomendations = (() => {
  let cart, cartRecomendations, cartRecomendationsSwiper, cartRecomendationsSwiperWrapper;

  async function init() {
    cart = document.getElementById('CartDrawer-CartItems');
    cartRecomendations = document.getElementById('cart-recommendations');
    cartRecomendationsSwiper = cartRecomendations.querySelector('.swiper');
    cartRecomendationsSwiperWrapper = cartRecomendations.querySelector('.swiper-wrapper');

    const productIds = getCartProductIds(cart);
    if (productIds.length) {
      const renderedHTML = await getRecomendations(productIds);

      if (renderedHTML.length) {
        cartRecomendationsSwiperWrapper.innerHTML = '';
        renderedHTML.forEach((item) => {
          cartRecomendationsSwiperWrapper.innerHTML += item;
        });

        let swiperInstance = null;

        function initSwiperIfNeeded() {
          const isMobile = window.matchMedia('(max-width: 1024px)').matches;

          if (!isMobile && !swiperInstance) {
            swiperInstance = new Swiper(cartRecomendationsSwiper, {
              loop: false,
              autoplay: {
                delay: 5000,
                stopOnLastSlide: true,
              },
              slidesPerView: 3.2,
              spaceBetween: 4,
              speed: 1200,
              mousewheel: {
                forceToAxis: true,
              },
            });
          }

          if (isMobile && swiperInstance) {
            swiperInstance.destroy(true, true);
            swiperInstance = null;
          }
        }

        initSwiperIfNeeded();
        window.addEventListener('resize', initSwiperIfNeeded);
        Wishlist.setWishlistListener();
      }
    }
  }

  function getCartProductIds(cart) {
    const ids = new Set();
    cart.querySelectorAll('.cart-item').forEach((item) => ids.add(parseInt(item.dataset.productId)));
    return [...ids];
  }

  async function getRecomendations(productIds) {
    const usedProducts = [];
    const fetches = productIds.map((id) =>
      fetch(
        window.Shopify.routes.root +
          `recommendations/products?product_id=${id}&limit=4&section_id=related-products&intent=complementary`
      )
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          let recommendations = html.querySelectorAll('.product-card-wrapper');
          let allProducts = '';

          recommendations.forEach((element) => {
            const productId = element.dataset.productId;

            if (!usedProducts.includes(productId)) {
              let classes = [];
              for (let className of element.classList) {
                classes.push(className);
              }
              classes = classes.join('\n');

              usedProducts.push(productId);

              allProducts += `
                <div class="swiper-slide">
                    <div class="${classes}" data-product-id="${productId}">
                        ${element.innerHTML}
                    </div>
                </div>
              `;
            }
          });

          return allProducts;
        })
        .catch((e) => {
          console.error(e);
        })
    );

    const allRecommendations = await Promise.all(fetches);

    return allRecommendations;
  }

  return {
    init,
  };
})();

document.addEventListener('DOMContentLoaded', () => {
  ProductCartRecomendations.init();
});
